export const columns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Name' },
    { id: 'age', label: 'Age' },
    { id: 'city', label: 'City' },
]

export const data = [
    { id: 1, name: 'John', age: 30, city: 'New York s' },
    { id: 2, name: 'Jane', age: 25, city: 'Los Angeles' },
    { id: 3, name: 'Bob', age: 35, city: 'Chicago' },
    { id: 4, name: 'John', age: 30, city: 'New York' },
    { id: 5, name: 'Jane', age: 25, city: 'Los Angeles' },
    { id: 6, name: 'Bob', age: 35, city: 'Chicago' },
    { id: 7, name: 'John', age: 30, city: 'New York' },
    { id: 8, name: 'Jane', age: 25, city: 'Los Angeles' },
    { id: 9, name: 'Bob', age: 35, city: 'Chicago' },
    { id: 10, name: 'John', age: 30, city: 'New York' },
    { id: 11, name: 'Jane', age: 25, city: 'Los Angeles' },
    { id: 12, name: 'Bob', age: 35, city: 'Chicago' },
]
